import React, {Component} from 'react';
import MyTable from "../component/MyTable";
import BaseComponent from "../../../base/BaseComponent";
import {HEADER_HEIGHT} from "../../../constants";
import {Modal, Popover, message, Button, Icon, Tooltip, Popconfirm, Input, Dropdown, Menu} from "antd";
import './ManuscriptsSubmitted.css'
import moment from "moment";
import {Scrollbars} from 'react-custom-scrollbars';
import {showStoryUrlConfig} from "./showStoryUrl-config";
import MediaList from "../../newsContribute/component/modal/mediaList";
import {getInfoFromLocalStorage} from "../../../actions";
import sonBtn from "../../newsContribute/component/img/sonBtn.png";
import {getColorByState} from "../../components/colorByState/colorByState";
import SimpleFloatTool from "../../editor/floatTool/simpleFloatTool";
import AddToEditor from "../../../components/resource-list/addToEditor";
import BaseTable from "../../components/baseTable/BaseTable";
import {uuid} from "../../../utils";
import RenderPicker from "./component/renderPicker";

const {confirm} = Modal;


class ManuscriptsSubmitted extends BaseComponent {
    // 3.5.0暂不需要图文合成器
    showMergeMaterial = false;
    currentUserMediaList = [];
    constructor(props) {
        super(props);
        this.state = {
            tabKey: '全部稿件',
            mediaCode: '',
            params: {
                mediaId: '',
                keywords: '',
                page: 1,
                size: 10,
            },
            dataSource: [],
            total: 10,// 数据总条数
            reviewData: 99,//待我审核数据
            treeData: [],
            webStory:{},//当前选中并跳转编辑器的稿件
            operateType: "", // contribute点击素材中心标题 / pickUp点击拾取器
            storyId: 0,
            mediaListModalVisible : false,
            mediaListData: [],
            publishMediaListModalVisible: false,
            publishMediaListData: [],
            wechatList: [], // 图文合成器列表
            synthesizer: {}, // 当前合成器所属媒体
            minus:true
        };
        //初始化当前媒体，因为需要判断当前用户是否有该稿件投向的媒体的权限，如果没有，则点击进去后不能显示任何按钮
        this.getCurrentUserMediaList();
    }

    componentWillMount() {
        if(!(this.props.dynamicParams && this.props.dynamicParams.display==="none")) {
            let that = this;
            // 监听 EditorInformationOfWebEditor 页面发送的消息
            this.createPostMessage((e) => {
                let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
                if (message == "请求媒体参数") {
                    // that.sendMediaParameters(e, that)
                } else if (message == "请求刷新父页面") {
                    // 同tab下切换刷新，避免不同tab接口冲突
                    that.tabChange(that.state.tabKey);
                    // that.getManuscripts();
                } else if (message == "更新稿件关系") {
                    let data = e['data'] ? JSON.parse(e['data'])['data'] : null;
                    // that.updateStoryRelation(data);
                }
            }, "ManuscriptsSubmitted")
        }
    }

    componentDidMount() {
        if(!(this.props.dynamicParams && this.props.dynamicParams.display==="none")) {
            this.getManuscripts();
        }
    };

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("ManuscriptsSubmitted")
    }

    render() {
        let {tabKey, total, dataSource, reviewData, params, treeData} = this.state;
        let navigationBarDate = this.getNavigationBarData();
        let props = {
            onChange: this.onChange,
            dataSource: dataSource, //表格数据
            total: total,
            navigationBarDate: navigationBarDate,
            columns: this.getColumns(),  //表格表头
            reviewData: reviewData,
            tabChange: this.tabChange,
            params: params,
            tabKey: tabKey,
            // tableWidth: window.innerWidth - 550 - 64,
            tableHeight: window.innerHeight - HEADER_HEIGHT - 101 - 20 - 81 - 15 - 15,
            // width: window.innerWidth - 550,
            treeData: treeData
        };
        return (
            <div>
                <MyTable
                    {...props}
                ></MyTable>
                {/*查看任务弹框*/}
                {this.renderModal()}
                {/*查看发布弹框*/}
                {this.renderViewPublishModal()}
                {/*查看提交媒体弹框*/}
                {this.renderSubmitMediaModal()}
                {/*渲染图文合成器*/}
                {this.showMergeMaterial?this.renderMergeMaterial():null}
            </div>
        );
    }

    //渲染图文合成器
    renderMergeMaterial = ()=>{
        let {wechatList, synthesizer} = this.state;
        let columns = [
            {
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 56,
                render: (record, text, index) => index + 1
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                ellipsis: true,
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                width: 80,
                render: (text, record) => {
                    return <span style={{ cursor: 'pointer', color: this.themeBgColor }} onClick={() => {
                        let wechatList = this.state.wechatList.filter(item=>item.id!=record.id);
                        this.setState({wechatList}, () => {
                            if(!wechatList || wechatList.length<1) {
                                // 删完后，折起并返回最初位置
                                this.simpleFloatTool.setMinus(true);
                                this.simpleFloatTool.setState({
                                    top: window.innerHeight - 80,
                                    left: 425
                                })
                            }
                        })
                    }}>删除</span>
                }
            }
        ];
        return <SimpleFloatTool
            title={
                <div>
                    <span style={{fontSize: 16,color: '#222222',}}>图文合成器</span>
                    <span style={{fontSize: 12,color: 'rgba(0, 0, 0, 0.45)',marginLeft:10}}>{synthesizer.name}</span>
                </div>
            }
            visible={true}
            minus={this.state.minus}
            left={425}
            top={window.innerHeight-80}
            style={{border: 'none'}}
            width={400}
            itemPaddingRight={0}
            onMinus={(minus)=>{
                if(minus) {
                    // 当合成器折起时，重新计算定位（回到最初位置）
                    this.simpleFloatTool.setState({
                        top:window.innerHeight-80,
                        left:425
                    })
                }
            }}
            footer={
                <div
                    style={{color: '#0050B3', display: 'flex', justifyContent: 'center'}}
                >
                    <Button onClick={()=>{
                        this.simpleFloatTool.setMinus(true);
                        this.setState({wechatList: []}, () => {
                            // 当合成器折起时，重新计算定位（回到最初位置）
                            this.simpleFloatTool.setState({
                                top: window.innerHeight - 80,
                                left: 425
                            })
                        })
                    }}>清空</Button>
                    <Button onClick={()=>{
                        this.addWechat({
                            medialId: synthesizer.id,
                            wechatList
                        })
                    }} type={'primary'} style={{marginLeft:20}} disabled={!(wechatList&&wechatList.length&&synthesizer&&synthesizer.id)}>拾取至编辑器</Button>
                </div>
            }
            ref={ref => this.simpleFloatTool = ref}
        >
            <BaseTable
                showHeader={false}
                columns={columns}
                dataSource={wechatList}
                rowKey={"id"}
            />
        </SimpleFloatTool>
    };

    // 新增微信图文
    addWechat = ({medialId, wechatList}) => {
        if(wechatList&&wechatList.length&&medialId) {
            let url = "/cm-sites/pms/framereact/index.html#/wechat/weiChatPublish/"+medialId;
            let addFun = () => {
                let stuffList = wechatList.map(item=>({
                    title: item.title,
                    author: item.submitterName,
                    titlePic: item.titlePic,
                    summary: (item.variableFields && item.variableFields.summary) ? item.variableFields.summary  : "",
                    content: this.filterContent(item.content),
                    url: item.url,
                    id: item.id,
                    afterFun: ["saveRelation"],
                }));
                window.openPage({
                    url,
                    params: {
                        stuffList,
                    },
                })
            };
            if(this.checkWechat(wechatList)) {
                addFun()
            } else {
                confirm({
                    title: '公众号编辑器不支持插入音视频，稿件中的音视频将会删除',
                    onOk:() =>{
                        addFun()
                    },
                    onCancel() {
                    },
                });
            }
        }
    };

    checkWechat = (wechatList) => {
        if(wechatList && wechatList.length) {
            return wechatList.some(item=>{
                let content = item.content;
                let regStr =
                    "(<\/?video.*?>)" +
                    "|(<\/?audio.*?>)" +
                    "|(<\/?[^>]*alias-label=\"video\".*?>)" +
                    "|(<\/?[^>]*alias-label=\"audio\".*?>)" +
                    "|(<\/?[^>]*video-src=.*?>)" +
                    "|(<\/?[^>]*audio-src=.*?>)";
                let reg = new RegExp(regStr,"g");
                let hasVideo = reg.test(content);
                return !hasVideo
            });
        } else {
            return true
        }
    };

    filterContent = (content) => {
        if(content) {
            // 过滤视频音频标签，以及以图片形式存储的视频音频标签（video-src   alias-label="video"）
            let regStr =
                "(<\/?video.*?>)" +
                "|(<\/?audio.*?>)" +
                "|(<\/?[^>]*alias-label=\"video\".*?>)" +
                "|(<\/?[^>]*alias-label=\"audio\".*?>)" +
                "|(<\/?[^>]*video-src=.*?>)" +
                "|(<\/?[^>]*audio-src=.*?>)"
            let reg = new RegExp(regStr,"g");
            let newContent = content.replace(reg,"");
            return newContent
        } else {
            return content
        }
    };

    getContributeTargetList = (ids, callBack)=>{
        this.request({
            url : "/cm-sites-pms/media/getMediaGroupByIds",
            body: {ids}, callBack
        })
    };

    renderSubmitMediaModal = ()=>{
        return (
            <>
                <Modal
                    title={"提交媒体"}
                    footer={null}
                    visible={this.state.mediaListModalVisible}
                    onOk={() => {
                        this.setState({mediaListModalVisible: false})
                    }}
                    onCancel={() => {
                        this.setState({mediaListModalVisible: false})
                    }}
                    maskClosable={false}
                    className={"rmt-renderSubmitMediaModal"}
                >
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={500}
                        autoHide={true}
                    >
                        <MediaList group={this.state.mediaListData}/>
                    </Scrollbars>
                </Modal>
                <style>
                    {
                        `
                        .rmt-renderSubmitMediaModal .ant-modal-body {
                            padding-top: 18px;
                            padding-bottom: 18px;
                        }
                        `
                    }
                </style>
            </>
        );
    };

    getPublishList = (storyId, callBack)=>{
        this.request({
            url : "/cm-sites-pms/story/viewRelease",
            body: {storyId}, callBack
        })
    };

    renderViewPublishModal = ()=>{
        return (
            <Modal
                title={"查看发布"}
                footer={null}
                visible={this.state.publishMediaListModalVisible}
                onOk={()=>{this.setState({publishMediaListModalVisible:false})}}
                onCancel={()=>{this.setState({publishMediaListModalVisible:false})}}
                maskClosable={false}
            >
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={500}
                    autoHide={true}
                >
                    <MediaList group={this.state.publishMediaListData} showHref={true}/>
                </Scrollbars>
            </Modal>
        )
    };

    //查看任务弹框
    renderModal = () => {
        return (
            <div className={'modalStyle'}>
                <Modal
                    centered={true}
                    title="任务信息"
                    visible={this.state.visible}
                    onCancel={this.hideModal}
                    style={{position: "relative", left: '-131px'}}
                >
                    <div style={{width: 716, height: 252}}>
                        <div>
                            <th className={'title'}>新闻报道</th>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div className={'modalLeft'}>
                                <div style={{paddingTop: '16px'}}>
                                    <span>任务名称:</span>
                                    <span>张三的任务</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>活动时间:</span>
                                    <span>2022-02-15 12;54</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>回稿时间:</span>
                                    <span>2022-02-15 12:54</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>活动联系人:</span>
                                    <span>张老师</span>
                                </div>
                            </div>
                            <div className={'modalRight'} style={{paddingLeft: '133px'}}>
                                <div style={{paddingTop: '16px'}}>
                                    <span>所属项目:</span>
                                    <span>-</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>活动地点:</span>
                                    <span>这是一个活动地点</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>主办单位:</span>
                                    <span>新闻中心</span>
                                </div>
                                <div style={{paddingTop: '16px'}}>
                                    <span>联系方式:</span>
                                    <span>130 0123 4567</span>
                                </div>
                            </div>
                        </div>

                        <div style={{paddingTop: '16px'}} className={'foot'}>
                            <span>任务内容:</span>
                            <span>fdsfdfgvtfhbgjnghkmjh,kkjlhtfstghhdrsgghfbhd</span>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    };

    // 渲染拾取按钮
    // renderPicker = ({widthValue,id,data,mediaClick}) => {
    //     let {treeData} = this.state;
    //     if(treeData){
    //         let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material").split(",");
    //         treeData = treeData.filter(item=>{
    //             return mediaTypes.indexOf(item.mediaTypeCode) > -1;
    //         });
    //     }
    //     return (
    //         <div style={{width:widthValue?widthValue:230,lineHeight:2}}>
    //             <Scrollbars style={{width:widthValue?widthValue:230,paddingRight:widthValue?"12px":0}}
    //                         autoHeight={true}
    //                         autoHeightMax={400}
    //             >
    //                 {treeData && treeData.length ? (
    //                     treeData.map((picker,index)=>{
    //                         return (
    //                             <div key={index}>
    //                                 {this.renderPickerItem({picker,id,data,mediaClick})}
    //                             </div>
    //                         )
    //                     })
    //                 ):null}
    //             </Scrollbars>
    //         </div>
    //     )
    // };

    // 渲染拾取器
    // renderPickerItem = ({picker,id,data,mediaClick}) => {
    //     return (
    //         <>
    //             <div style={{display: 'flex',alignItems: 'center'}}>
    //                 {/*<Icon type="border-outer" />*/}
    //                 <img src={picker.logoUrl} width={16} style={{marginRight:5}}/>
    //                 <div style={{color:"#a0a0a0"}}>{picker.mediaTypeName}</div>
    //             </div>
    //             <div>
    //                 {picker && picker.mediaList && picker.mediaList.length ?(
    //                     picker.mediaList.map((media,index)=>{
    //                         let checked = media.checked;
    //                         return (
    //                             media.authResult === 1 ?
    //                             <div className={`text-pointer text-pointer-color ${checked?"text-pointer-checked":""}`} onClick={()=>{
    //                                 this.state.treeData.forEach(item1 => {
    //                                     item1.mediaList.forEach(item2 => {
    //                                         item2.checked = false;
    //                                         if (item1.id === picker.id && media.id === item2.id) {
    //                                             item2.checked = checked ? false : true;
    //                                         }
    //                                     })
    //                                 });
    //                                 this.setState({});
    //                                 if(typeof mediaClick === "function"){
    //                                     mediaClick(media);
    //                                     return
    //                                 }
    //                                 this.onClickPicker({media,id,data})
    //                             }} style={{padding:"4px 0 4px 21px",cursor:'pointer'}} key={index}>
    //                                 {media.name}
    //                             </div>
    //                                 :
    //                             <div className={"text-pointer text-pointer-color"} onClick={()=>{
    //                                 message.destroy();
    //                                 message.warning("不可拾取至未认证媒体！");
    //                             }
    //                             } style={{padding:"4px 0 4px 21px",cursor:'pointer'}} key={index}>
    //                                 {media.name + "（未认证）"}
    //                             </div>
    //                         )
    //                     })
    //                 ):null}
    //             </div>
    //             <style>
    //                 {
    //                     `
    //                     .text-pointer-color {border:1px solid transparent}
    //                     .text-pointer-color:hover {border-color:#E2EBF6;background:#F5F8FC}
    //                     .text-pointer-checked {border:1px solid #E2EBF6;background:#F5F8FC}
    //                      `
    //                 }
    //             </style>
    //         </>
    //     )
    // };

    //tab栏切换
    tabChange = (key, isTabChange=true) => {
        this.state.tabKey = key;
        let data = this.getTabDataByKey(key);
        if(isTabChange) { // 切换tabbar重置查询参数
            this.state.params.size = 10;
            this.state.params.page = 1;
        }
        if(["待我审核", "我已审核"].indexOf(this.state.tabKey) > -1) {
            return this.getActivityDataSource(data)
        }
        this.getManuscripts();
    };
    
    getTabDataByKey = (key)=>{
        let data = this.getNavigationBarData();
        let result = {};
        data.map(item => {
            if(item.key === key){
                result = item;
            }
        });
        return result;
    };

    getContributeIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "likewebsite"){
                if(item.data && item.data.targetIds && (item.data.targetIds instanceof Array) && (item.data.targetIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示，  这里是转换投稿返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertContributeInfo = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/contribute/getContributeInfo",
            body:{ids},callBack
        });
    };

    getMediaNewIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey !== "likewebsite"){
                ids.push(item.data.id);
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示,这里是转换网站返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertReceiveInfoByMediaNews = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/contribute/getReceiveInfoByMediaNews",
            body:{ids},callBack
        });
    };

    getReceiveIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "likewebsite"){
                if(item.data && item.data.mediaIds && (item.data.mediaIds instanceof Array) && (item.data.mediaIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示,这里是转换收稿返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertReceiveInfo = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/material/getReceiveInfo",
            body:{ids},callBack
        });
    };


    getActivityDataSource=(data)=>{
        let title = '';
        let size = 10;
        let start = 1;
        if(this.state.params){
            title = this.state.params.keywords;
            size = this.state.params.size;
            start = this.state.params.page;
        }
        let params = data.params;
        params.title = title;
        params.page.size = size;
        params.page.start = start;
        let url = data.url;
        let that = this;
        this.request({
            url,
            method: 'post',
            body: params,
            contentType:'json',
            callBack: function (res) {
                let dataSource = [];
                let total = 0;
                if (res && res.data && res.data.length) {
                    total = res.count;
                    dataSource = res.data;
                }
                that.state.total = total;
                that.state.dataSource = dataSource && dataSource.length ? dataSource.map(item=>item.data) : [];
                that.setState({});
                let newDataSource = that.state.dataSource;
                if (newDataSource && newDataSource.length) {
                    let convertContributeStory = (storys, call) => {
                        for (let i = 0; newDataSource && i < newDataSource.length; i++) {
                            let item = newDataSource[i];
                            for (let j = 0; j < storys.length; j++) {
                                let story = storys[j];
                                call(item, story);
                            }
                        }
                        that.setState({})
                    };

                    let contributeIds = that.getContributeIds(dataSource);
                    contributeIds.length > 0 && that.activitiDataConvertContributeInfo(contributeIds, (data) => {
                        convertContributeStory(data, (item, story) => {
                            if (item.id === story.id) {
                                item.contributeMedia = story.submitTarget;
                                item.mediaIds = story.targetIds;
                                item.targetType = story.targetType;
                                item.mediaLogo = story.mediaLogo;
                            }
                        })
                    });

                    let mediaNewIds = that.getMediaNewIds(dataSource);
                    mediaNewIds.length > 0 && that.activitiDataConvertReceiveInfoByMediaNews(mediaNewIds, (data) => {
                        convertContributeStory(data, (item, story) => {
                            if (item.id === story.mediaNewsId) {
                                item.contributeMedia = story.contributeMedia;
                                item.mediaIds = story.mediaIds;
                                item.targetType = "media";//收稿的不区分投稿方式，只管是否投到了这个媒体下
                                item.submitter = story.submitter;
                                item.submitterName = story.submitterName;
                                item.mediaLogo = story.mediaLogo;
                                item.id = story.id;
                                item.mediaNewsId = story.mediaNewsId;
                                item.openEditorStyle = "materialCenterWebEditor";//代表是收稿稿件，要打开收稿的编辑器
                            }
                        })
                    });

                    let receiveIds = that.getReceiveIds(dataSource);
                    receiveIds.length > 0 && that.activitiDataConvertReceiveInfo(receiveIds, (data) => {
                        convertContributeStory(data, (item, story) => {
                            if (item.id === story.id) {
                                item.contributeMedia = story.contributeMedia;
                                item.mediaIds = story.mediaIds;
                                item.targetType = "media";//收稿的不区分投稿方式，只管是否投到了这个媒体下
                                item.submitter = story.submitter;
                                item.submitterName = story.submitterName;
                                item.mediaLogo = story.mediaLogo;
                                item.mediaNewsId = story.id;
                                item.openEditorStyle = "receiveEditor";//代表是收稿稿件，要打开收稿的编辑器
                            }
                        })
                    });
                }
            },
            errorCallBack: function (e) {
            }

        });
    };


    //获取tab栏数据
    getManuscripts = () => {
        let {tabKey, params} = this.state;
        let navigationBarDate = this.getNavigationBarData();
        // 根据 tabKey 获取 navigationBarDate 中对应的对象
        let thisTab = navigationBarDate.find(item => item.key == tabKey);
        // 根据上面获取的对象,取到url
        let url = thisTab.url;
        let newParams = JSON.parse(JSON.stringify(params));
        if(thisTab.params) {
            newParams = {
                ...newParams,
                ...thisTab.params
            }
        }
        this.request({
            url,
            body: newParams,
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res) {
                    total = res.count;
                    dataSource = res.data;
                }
                this.setState({
                    total,
                    dataSource,
                })
            },
            errorCallBack: (e) => {
            },
        })
    };

    //搜索功能
    onChange = (type, e) => {
        let {params} = this.state;
        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                params['page'] = 1;
                break;
            case 'onSelect':
                params['mediaId'] = e;
                break;
            case 'page':
                params['page'] = e;
                break;
            case 'size':
                params['size'] = e;
                params['page'] = 1;
                break;
        }
        this.tabChange(this.state.tabKey, false);
    };

    //查看任务弹框
    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    //查看任务弹框
    hideModal = () => {
        this.setState({
            visible: false,
        });
    };

    download = (record)=>{
        let storyId = record.id;
        this.request({
            url:"/cm-sites-pms/story/download",
            body:{storyId},
            method:"downloadPost"
        })
    };

    //移除
    delete = (record) => {
        let id = record.id;
        this.request({
            url: '/cm-sites-pms/story/remove',
            method: 'post',
            // contentType: 'json',
            body: {'storyId': id},
            callBack: (res) => {
                if (res) {
                    message.success("移除成功")
                } else {
                    message.error("移除失败")
                }
                // this.getManuscripts();
                this.tabChange(this.state.tabKey,false)
            },
            errorCallBack: () => {
            },
        })

    };

    //点击拾取按钮
    // onClickPicker = ({media={},id=0,data=null}) => {
    //       let mediaNewsType = media.mediaTypeCode;
    //       if(!mediaNewsType || !id) return message.info("参数丢失");
    //       this.jumRoute(media,(res)=>{
    //          if(res) {
    //              this.pickerFunc({medialId:media.id,mediaNewsType,id,data});
    //          } else {
    //              message.destroy();
    //              message.error('请联系管理员绑定网站用户管理员！')
    //          }
    //       });
    // };

    //媒体绑定事件
    // jumRoute(media,call) {
    //     if (media.mediaTypeCode == 'webNews' && media.authResult == 1) {
    //         this.mediaBinding(media, (res) => {
    //             if (!res) {
    //                 call&&call(false)
    //             } else {
    //                 call&&call(true)
    //             }
    //         })
    //     }else if(media.mediaTypeCode == 'webNews' && media.authResult == 0){
    //         message.destroy()
    //         message.error('媒体未认证，请在媒体管理中对媒体进行认证！')
    //     }
    //     else if (!(media.mediaTypeCode == "material" && media.authResult == 0)) {
    //         call&&call(true)
    //     }
    // }

    //媒体绑定功能
    // mediaBinding = (media, callback) => {
    //     this.request({
    //         url: '/cm-sites-pms/website/getVsbUser',
    //         body: {
    //             mediaId: media.id,
    //             userId: window.currentUser.id
    //         },
    //         callBack: (res) => {
    //             callback(res)
    //         },
    //         serverVerify:{
    //             serverErrorCallBack:()=>{
    //                 message.destroy();
    //                 message.error('请联系管理员添加融媒发布媒体权限！')
    //             },
    //             isShowErrorMsg:false
    //         },
    //         errorCallBack: (e) => {
    //         },
    //     })
    // };

    // 拾取操作
    // pickerFunc = ({medialId,mediaNewsType,id,data}) => {
    //     if(mediaNewsType && id && (typeof (this["pickerFuncTo"+mediaNewsType]) == 'function')) {
    //         this["pickerFuncTo"+mediaNewsType]({medialId,mediaNewsType,id,data})
    //     }
    // };

    // 拾取到网站
    // pickerFuncTowebNews = ({mediaNewsType,id}) => {
    //     let that = this;
    //     let body = {mediaNewsType,storyId:id};
    //     let config  = showStoryUrlConfig[mediaNewsType] || {};
    //     let urls = config['urls'] || {};
    //     let url = urls['pickerUrl'];
    //     let configName = config['pickerModule']; // 拾取稿件到网站，应该直接用网站编辑器打开
    //     if (!(id && id.length > 1 && url && mediaNewsType && configName)) {
    //         return;
    //     }
    //     that.state.operateType = "pickUp";
    //     that.state.storyId = id;
    //     this.request({
    //         url,
    //         body,
    //         callBack: function (res) {
    //             let webStory = {};
    //             let id = 0;
    //             if (res) {
    //                 webStory =  res
    //                 // 拾取稿件每次都是新增，不需要传递id
    //             }
    //             that.state.webStory = webStory;
    //             //获取投稿流程的code
    //             let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
    //             that.state.editorWindow = window.openEditById({configName, id, params:{
    //                     activitiConfName,
    //                     webStory,
    //                     storyId: that.state.storyId,
    //                     operateType: "contribute"
    //                 }})
    //         },
    //         errorCallBack: function (res) {
    //             message.error('稿件加载失败！');
    //         }
    //     });
    // };

    // 拾取到微信
    // pickerFuncTomaterial = ({medialId,mediaNewsType,id,data}) => {
    //     if(medialId && data) {
    //         // 等同于在合成器中添加了一篇文章然后提交公众号
    //         this.addWechat({
    //             medialId,
    //             wechatList:[data]
    //         })
    //     } else {
    //         message.info("参数丢失");
    //     }
    // };

    // 点标题跳转编辑器
    jumpEditor = ({mediaCode, id, hideBtn, mustNotShowPublishBtn}) => {
        let that = this;
        that.state.operateType = "contribute";
        // 根据storyId获取网站文章内容
        let config = showStoryUrlConfig[mediaCode] || {};
        let parseOpenModule = (openModule)=>{
            let result = {};
            for(let attr in openModule){
                let attrValue = openModule[attr];

                if((typeof attrValue === "string") && /\${.*}$/.test(attrValue)){
                    let expression = attrValue.replace(/\${(.*)}$/,"$1");
                    let valueExeResult = eval(expression);
                    result[attr] = valueExeResult;
                }else{
                    result[attr] = attrValue;
                }
            }
            return result;
        };
        if(config.style === "noAjax"){
            if(!config.openModule){
                message.error(`showStoryUrlConfig[${mediaCode}].openModule配置不不存在`);
            }else{
                let result = parseOpenModule(config.openModule);
                result.params.operateType = "contribute";
                result.params.hideBtn = hideBtn;
                that.state.editorWindow = window.openEditById({...result});
            }
            return;
        }

        let urls = config['urls'] || {};
        let url = urls['titleUrl'];
        let idKey = config['idKey'];
        let configName = config['module'];
        if (!(id && id.length > 1 && url && idKey && configName)) {
            return;
        }
        that.state.storyId = id;
        this.request({
            url,
            body: {[idKey]: id},
            callBack: function (res) {
                if(!res){
                    message.warn("媒体编辑已将稿件删除");
                    return false;
                }
                let webStory = {};
                let id = 0;
                webStory = res;
                id = res.id || 0;
                that.state.webStory = webStory;
                let operateType = that.state.operateType;
                let storyId = that.state.storyId;
                //获取投稿流程的code
                let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
                that.state.editorWindow = window.openEditById({
                    configName, id, params: {
                        activitiConfName,
                        webStory,
                        operateType,
                        storyId,
                        hideBtn,
                        mustNotShowPublishBtn
                    }
                });
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }
        });
    };

    // 刷新稿件关系
    updateStoryRelation = (data) => {
        if(!data) return false;
        this.request({
            url: "/cm-sites-pms/story/saveRelation",
            method: "post",
            body: {
                mediaNewsId: data.mediaNewsId, // 网站稿件id
                mediaNewsType: data.mediaNewsType, // 网站媒体type
                operateType: data.operateType, // contribute 点击素材中心标题 / pickUp 点击拾取器
                storyId: data.storyId, // 原稿件Id
            },
            callBack: (res) => {
                if(res) {
                    console.log("更新稿件关系成功！")
                }
            }
        })
    };
    // 表头
    getColumns() {
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    ellipsis: true,
                    width: 230,
                    render: (text, record) => {
                        let title = text;
                        let id = record.id;
                        let mediaCode = record.mainMedia && record.mainMedia.mediaTypeCode || "";
                        let mediaId = (record.mainMedia && record.mainMedia.id) || (record.mediaId) || "0";
                        return (
                            <div className={'titleContent'}>
                                {/*点击跳转*/}
                                    <div
                                        title={title}
                                        style={{
                                            maxWidth:'calc( 100% - 32px )',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            marginRight:8,
                                        }}
                                        onClick={() => {
                                            window.openEditById({
                                                configName: showStoryUrlConfig["manuscriptsSubmitted"]["openModule"]["configName"],
                                                id: record.id,
                                                params: showStoryUrlConfig["manuscriptsSubmitted"]["openModule"]["params"]
                                            });
                                            return;

                                            let hideBtn = !this.currentUserHasMediaAuth(mediaId);
                                            let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
                                            if (record.openEditorStyle) {
                                                this.state.operateType = "contribute";
                                                window.openEditById({
                                                    configName: record.openEditorStyle,
                                                    id: record.mediaNewsId,
                                                    params: {
                                                        hideBtn,
                                                        operateType: "contribute"
                                                    }
                                                })
                                            } else {
                                                if (id && mediaCode) {
                                                    this.state.mediaCode = mediaCode;
                                                    let mustNotShowPublishBtn = noPublishConfig.indexOf(record.statusName)>-1?false :true
                                                    mustNotShowPublishBtn = false; // 这个判断在编辑器里面已经执行了，外层不用再执行，稿件发布后这个参数就不对了（在不退出编辑器的情况下）。这里应该做的是当前稿件当前人永远不能发布的情况。
                                                    this.jumpEditor({mediaCode, id, hideBtn,mustNotShowPublishBtn})
                                                } else {
                                                    message.error("稿件id丢失或稿件媒体丢失")
                                                }
                                            }
                                        }}
                                    >{title}</div>
                                {/*点击弹窗*/}
                                {record.hasSons ?
                                    <img onClick={()=>{this.setState({
                                        visible: true
                                    })}} src={sonBtn} style={{width:24,height:24}}/>
                                    : null}
                            </div>
                        )
                    },
                },
                {
                    title: '来稿单位',
                    dataIndex: 'sourceDeptName',
                    width: 100,
                    render: (text) => {
                        return (
                            <div title={text} style={{
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                whiteSpace: 'nowrap'
                                }}>
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: '投稿至',
                    dataIndex: 'contributeMedia',
                    key: 'contributeMedia',
                    width: 280,
                    render: (text, record) => {
                        let mediaName = text&&text.length?text[0]:(record.mediaName || '');
                        let media=(<div style={{display:'flex'}}>
                            <span className={"text-pointer"} style={{maxWidth:100}}><div title={!text?"":text.join("，")} style={{overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',}}>{mediaName}</div></span>
                            {
                                text&&text.length>1?<div style={{padding:"0 5px"}}>等<span
                                    onClick={()=>{
                                        if(record.mediaIds && record.mediaIds.length > 1){
                                            this.getContributeTargetList(record.mediaIds.join(","), (data)=>{
                                                let convertData = ()=>{
                                                    let result = [];
                                                    for(let i = 0; data && i < data.length; i++){
                                                        let item = data[i];
                                                        result[i] = {icon: item.logoUrl, type:item.mediaTypeName, data: item.mediaList?item.mediaList.map(media=>{return {name:media.name}}):[]};
                                                    }
                                                    return result;
                                                };
                                                let mediaListData = convertData();
                                                this.setState({mediaListModalVisible:true, mediaListData});
                                            });
                                        }
                                    }}
                                    style={{color:"red",padding:"0 5px",cursor:"pointer"}}>{text.length}</span>个媒体</div>:null
                            }
                        </div>);
                        let oIcon = record.mediaLogo?<img src={record.mediaLogo} className={'oIcon'}/>:null;
                        return (
                            <div className={'media'}>
                                {oIcon}
                                {media}
                            </div>
                        )
                    }
                },
                {
                    title: '创建人',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width: 120,
                    render: (text, record) => {
                        let txt = text || record.createUserName || record.creatorName || "";
                        if(txt&&txt.length>4) {
                            txt = txt.substring(0,4)+"..."
                        }
                        return  <div title={text}>{txt} </div>
                    }
                },
                {
                    title: '修改时间',
                    dataIndex: 'updateTime',
                    key: 'updateTime',
                    width: 180,
                    render: (text, record) => {
                        let createTime = record.createTime ? moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        let updateTime = record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        return (
                            <div>
                                <div title={`创建时间: ${createTime}，修改时间: ${updateTime}`}>{updateTime}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width: 150,
                    render: (text) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color}}></div>
                                {/*<Tooltip placement={"topLeft"} title={text}>*/}
                                    <span title={text} className={"text-pointer"} style={{width:130}}>{text}</span>
                                {/*</Tooltip>*/}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    dataIndex: 'action',
                    width: 250,
                    render: (text, record) => {
                        let currentUser = getInfoFromLocalStorage("currentUser");
                        let currentDeptValue;
                        if(
                            currentUser &&
                            currentUser["defaultInfo"] &&
                            currentUser["defaultInfo"]["dept"] &&
                            currentUser["defaultInfo"]["dept"]["name"]
                        ) {
                            currentDeptValue = currentUser["defaultInfo"]["dept"]["name"];
                        }

                        let btns = [];

                        // downloadBtn  Start
                        let downloadBtn = <Button key={"downloadBtn"} size={'small'} type={'link'} onClick={() => {
                            this.download(record)
                        }} style={{marginLeft: -8}}>下载</Button>;
                        btns.push(downloadBtn);
                        // downloadBtn  end

                        // otherBtn  Start
                        // if((record.statusName == '发布' || record.statusName == '已发布') && record.mainMedia && record.mainMedia.mediaTypeCode === "webNews") {
                        if(record.variableFields&&record.variableFields.publish===1) {
                            let otherBtn =  <Button key={"otherBtn"} size={'small'} type={'link'} className='aPopover' style={{background:"unset"}} onClick={()=>{
                                    this.getPublishList(record.id, (data)=>{
                                        let publishMediaListData = this.convertDataByPublishList(data);
                                        this.setState({publishMediaListModalVisible:true, publishMediaListData})
                                    });
                                }}>查看发布</Button>;
                            btns.push(otherBtn);
                        }
                        // otherBtn  end

                        // storyPicker  Start
                        if(["发布", "已发布", "撤稿", "已撤稿", "已采用"].indexOf(record.statusName) > -1){
                            let storyPicker = <Popover key={"storyPicker"}
                                // content={this.renderPicker({id:record.id,data:record})}
                                content={<RenderPicker id={record.id} data={record} treeData={this.state.treeData}/>}
                                placement="bottomRight"
                            >
                                <Button size={'small'} type={'link'} className='aPopover' style={{background:"unset"}}>拾取至</Button>
                            </Popover>;
                            btns.push(storyPicker);
                        }
                        // storyPicker  end


                        // mergeMaterial  Start
                        if(record.mainMedia && record.mainMedia.mediaTypeCode === "material" && this.showMergeMaterial) { // 主媒体为微信
                            if (record.statusName &&
                                (
                                    // record.statusName.startsWith(`提交至${currentDeptValue}`) ||
                                    // record.statusName.indexOf("修改完成") !== -1 ||
                                    record.statusName.indexOf("已采用") !== -1
                                )) { // 状态为提交至
                                // if(this.getMediaPower(record.mainMedia.id)) { // 有当前媒体权限
                                if(this.currentUserHasMediaAuth(record.mainMedia.id)) { // 有当前媒体权限
                                    let mergeMaterial = <Button key={"mergeMaterial"} size={'small'} type={'link'} onClick={()=>{
                                        this.getMediaInfo(record.mainMedia.id, ({code,log})=>{
                                            if(code===1) {
                                                // 取当前媒体
                                                let oldSynthesizer = this.state.synthesizer;
                                                // 如果当前媒体与之前选择不一致则覆盖掉，并且清空合成器
                                                if(!oldSynthesizer || (oldSynthesizer.id != record.mainMedia.id)) {
                                                    this.state.synthesizer = record.mainMedia;
                                                    this.state.wechatList = [];
                                                }
                                                // 如果合成器中没有这篇稿子则添加
                                                if(!(this.state.wechatList && this.state.wechatList.some(item=>item.id==record.id))) {
                                                    this.state.wechatList.push(record);
                                                }
                                                // 打开合成器
                                                this.setState({},()=>{
                                                    // 展开合成器
                                                    this.simpleFloatTool.setMinus(false);
                                                    // 显示合成器
                                                    this.simpleFloatTool.show()
                                                });
                                            }
                                            if(code===0 && log && (typeof log === "string")) {
                                                message.warning(log)
                                            }
                                            if(code===-1 && log) {
                                                console.error(log)
                                            }
                                        });

                                    }}>图文合成器</Button>;
                                    btns.push(mergeMaterial);
                                }
                            }
                        }
                        // mergeMaterial  end

                        // failure  Start
                        if(record.statusName == '发布失败') {
                            let failure = (<span  key={"failure"} className={"Failure"}>
                                <Popconfirm getPopupContainer={triggerNode => triggerNode.parentNode}
                                            title={this.state.errorInfoValue}>
                                    <Button size={'small'} type={'link'} onClick={() => {
                                        this.getFailure(record.id)
                                    }}>失败原因</Button>
                                </Popconfirm>
                                <style>{`.Failure .ant-popover-buttons{display:none !important;} `}</style>
                            </span>);
                            btns.push(failure);
                        }
                        // failure  end

                        // delBtn  Start
                        if(record.statusName.startsWith(`提交至${currentDeptValue}`) || (["弃用", "已弃用", "撤稿", "已撤稿", "发布", "已发布", "采用", "已采用", "修改完成并提交"].indexOf(record.statusName) > -1)) {
                            let delBtn =
                                <Popconfirm key={"delBtn"} title="确定要移除吗？" okText="确定" cancelText="取消" onConfirm={() => {
                                    this.delete(record)
                                }}>
                                    {
                                        (record.statusName.startsWith(`提交至${currentDeptValue}`) || (["弃用", "已弃用", "撤稿", "已撤稿", "发布", "已发布", "采用", "已采用", "修改完成并提交"].indexOf(record.statusName) > -1)) &&
                                        <Button size={'small'} type={'link'}>移除</Button>
                                    }
                                </Popconfirm>;
                            btns.push(delBtn);
                        }
                        // delBtn  end

                        return (
                            <div className={'a'}>
                                {
                                    btns&&btns.length?(
                                        btns.map((btn,index)=>{
                                            if(index<3) {
                                                return btn
                                            }
                                            if(index===3) {
                                                let menus = btns.slice(3,btn.length);
                                                menus= (
                                                    <Menu>
                                                        {
                                                            menus.map((menu,Index)=>(
                                                                <Menu.Item key={Index}>
                                                                    {menu}
                                                                </Menu.Item>
                                                            ))
                                                        }
                                                    </Menu>
                                                );
                                                return (
                                                    <Dropdown overlay={menus} placement="bottomLeft" key={index}>
                                                        <Icon type="ellipsis" />
                                                    </Dropdown>
                                                )
                                            }
                                        })
                                    ):null
                                }
                            </div>
                        )
                    },
                },
            ]
        )
    };

    /**
     * 处理查看发布数据
     * @param { object } data 查看发布接口返回的数据
     * @return { array } group 处理完的数据，根据媒体类型进行分类汇总
     * */
    convertDataByPublishList = (data) => {
        let group = [];
        let names = [];
        for(let i = 0; data && i < data.length; i++){
            let item = data[i];
            if(item.mediaType){
                let index = names.indexOf(item.mediaType);
                if(index === -1){//不存在
                    if(!item.contentName){
                        group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName}]});
                    }else{
                        group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName + "/" + item.contentName}]});
                    }
                    names.push(item.mediaType);
                }else{
                    if(!item.contentName){
                        group[index].data.push({href: item.linkUrl, name: item.mediaName});
                    }else{
                        group[index].data.push({href: item.linkUrl, name: item.mediaName + "/" + item.contentName});
                    }
                }
            }
        }
        return group;
    };

    getFailure(id) {
        this.request({
            url: "/cm-sites-pms/story/getMediaNewsByStory",
            body: {storyId: id},
            callBack: (res) => {
                console.log("nnnnnnnnnnn",res.id)
                if(res && res.id){
                    this.request({
                        url: "/cm-sites-pms/index/publishLog",
                        body: {id: res.id},
                        callBack: (data) => {
                            let errorInfoValue =""
                            if(data){
                                errorInfoValue = data.errorInfo
                            }
                            this.setState({errorInfoValue})
                        }
                    })
                }
            }
        })
        // this.request({
        //     url: "/cm-sites-pms/index/publishLog",
        //     body: {id: id},
        //     callBack: (data) => {
        //         let errorInfoValue =""
        //         if(data){
        //             errorInfoValue = data.errorInfo
        //         }
        //         this.setState({errorInfoValue})
        //
        //     }
        // })
    }


    getMediaPower = async (mediaId) => {
        if (!mediaId) {
            return false
        }
        // 判断操作权限start
        let flag = false;
        let currentMediaList = getInfoFromLocalStorage("currentMediaList");
        if(!currentMediaList) {
            currentMediaList = await this.getCurrentMediaList()
        }
        if(currentMediaList && currentMediaList.length) {
            if(currentMediaList.find(item=>item&&item.mediaList&&item.mediaList.find(item2=>item2.id===mediaId))){
                flag = true;
            }
        }
        return flag
        // 判断操作权限end
    };

    //当前用户是否有该媒体的权限
    currentUserHasMediaAuth = (mediaId)=>{
        let media = this.currentUserMediaList.find(media=>media.id === mediaId);
        return media !== undefined;
    };

    // 获取单媒体信息
    getMediaInfo = (mediaId,call) => {
        if(!mediaId) return false;
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {mediaId},
            callBack: (res) => {
                //res.authResult === 0 未认证
                //res.disable === 1 被禁用
                if (res) {
                    if (res.authResult === 0) {
                        call && call({code: 0, log: "该媒体未认证"});
                        return false;
                    }
                    if (res.disable === 1) {
                        call && call({code: 0, log: "该媒体被禁用"});
                        return false;
                    }
                    call && call({code: 1, log: "媒体信息正常"});
                    return false;
                }
                call && call({code: -1, log: "未查到媒体信息"})
            },
            errorCallBack: (e) => {
                call&&call({code:-1,log:e.toString()})
            }
        })
    };

    getCurrentUserMediaList = ()=>{
        this.request({
            url : "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
            callBack: (data)=>{
                // 过滤禁用的媒体
                let newData = data && data.map(item=>({
                        ...item,
                        mediaList: item.mediaList && item.mediaList.filter(media=>{
                            return  media.disable == 0;
                        })
                    }));
                newData && newData.map(item=>{
                    item && item.mediaList && item.mediaList.map(media=>{
                        this.currentUserMediaList.push(media);
                    });
                });
                // 素材中心这里只保留网站和微信稿件
                if(newData){
                    let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material").split(",");
                    newData = newData.filter(item=>{
                        return mediaTypes.indexOf(item.mediaTypeCode) > -1;
                    });
                }
                this.setState({
                    treeData: newData
                });
            }
        })
    };

    // tabbar数据
    getNavigationBarData = () => {
        return (
            [
                {
                    key: '全部稿件',
                    url: '/cm-sites-pms/story/material/all',
                },
                {
                    key: '待我审核',
                    url: '/cm-sites-sys/process/getTodoList',
                    params: {
                        showData:true,
                        operatorUser: this.getInfo().currentUser.id,
                        // activitiCategoryKeys: ['storyToWebNews', 'tggj'],
                        activitiCategoryKeys: ['likewebsite'],
                        title: '',
                        // category: 'contribute',
                        page:{
                            start: 1,
                            size: 10,
                        }
                    }
                },
                // {
                //     key: '我已审核',
                //     url: '/cm-sites-sys/process/getMyFinished',
                //     params: {
                //         showData:true,
                //         operatorUser: this.getInfo().currentUser.id,
                //         // activitiCategoryKeys: ['storyToWebNews', 'tggj'],
                //         activitiCategoryKeys: ['likewebsite'],
                //         title: '',
                //         page:{
                //             start: 1,
                //             size: 10,
                //         }
                //     }
                // },
                {
                    key: '审核中',
                    url: '/cm-sites-pms/story/material/review',
                },
                // {
                //     key: '已发布',
                //     url: '/cm-sites-pms/story/material/publish',
                // },
                // {
                //     key: '已弃用',
                //     url: '/cm-sites-pms/story/material/abandon',
                // },
                // {
                //     key: '已撤稿',
                //     url: '/cm-sites-pms/story/material/withdraw',
                // },
                {
                    key: '返回修改',
                    url: '/cm-sites-pms/story/material/current/dept/story',
                    params: {
                        statusName: "已返回写稿人"
                    }
                },
                {
                    key: '已采用',
                    url: '/cm-sites-pms/story/material/current/dept/story',
                    params: {
                        statusName: "已采用"
                    }
                },
                {
                    key: '已弃用',
                    url: '/cm-sites-pms/story/material/current/dept/story',
                    params: {
                        statusName: "已弃用"
                    }
                },
            ]
        )
    }

}


export default ManuscriptsSubmitted;